/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Beitragsgruppenschluesselav2Inputs */



/**

* @param {_Field_Beitragsgruppenschluesselav2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_beitragsgruppenschluesselav2 = /** @type {((inputs?: _Field_Beitragsgruppenschluesselav2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Beitragsgruppenschluesselav2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Beitragsgruppenschlüssel AV")
});
export { _field_beitragsgruppenschluesselav2 as "_field_beitragsgruppenschluesselAV" }